// extracted by mini-css-extract-plugin
export var footer = "footer-module--footer--Z1xkR";
export var footerBottom = "footer-module--footer-bottom--A9C0z";
export var footerNav = "footer-module--footer-nav--Nmfvq";
export var footerSignup = "footer-module--footer-signup--zgYgM";
export var links = "footer-module--links--LTQh5";
export var logo = "footer-module--logo--Yt86o";
export var socials = "footer-module--socials--CAGJg";